import { FC } from "react";
import { Snackbar, Alert } from "@kamstrup/kfl";

export type Severity = "error" | "success" | "warning" | "info";

interface NotificationMessageProps {
  message: string;
  severity: Severity;
  visible: boolean;
  onClose: () => void;
}

export const NotificationMessage: FC<NotificationMessageProps> = ({
  message,
  severity,
  visible,
  onClose
}) => {
  return (
    <Snackbar
      open={visible}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert severity={severity} onClose={onClose} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};
